module.exports = __webpack_public_path__ + "media/2x/graph-45@2x-5d913a7c.png";